export default function ActivityFactory(UrlFactory, Error, houseService) {
    const factory = this;
    factory.findActivityBySlug = function (slug, activities) {
        let found = null;
        angular.forEach(activities, function (activity) {
            if (UrlFactory.slugify(activity.Name) == UrlFactory.slugify(slug)) {
                found = activity;
            }
        });
        if (!found) {
            return new Error("no-activity", "Aktiviteten blev ikke fundet");
        }
        return found;
    };

    factory.getById = function (id, activities) {
        let found = null;
        angular.forEach(activities, function (activity) {
            if (activity.CategoryID == id) {
                found = activity;
            }
        });
        if (!found) {
            return new Error("no-activity", "Aktiviteten blev ikke fundet");
        }
        return found;
    };

    factory.getCurrentActivity = function () {
        return houseService.searchFilter.houseCategory;
    };

    /**
     * refactor to HouseService / other factory ?
     */
    factory.findActivityByName = function (activityName) {
        return houseService.getActivities().then(function (activities) {
            if (!activityName) {
                return activities[0]; // default : alle aktiviteter
            }

            let found = null;
            angular.forEach(activities, function (activity) {
                if (activity.Name.toLowerCase() == activityName) {
                    found = activity;
                }
            });
            if (!found) {
                return new Error("no-activity", "Aktiviteten blev ikke fundet");
            }
            return found;

            // const oActivity = (factory.params.activity); // HouseCategory
        });
    };

    /**
     * LEGACY - refactor to HouseService / other factory ?
     */
    factory.findActivityById = function (activityId) {
        return houseService.getActivities().then(function (activities) {
            if (!activityId) {
                return activities[0]; // default : alle aktiviteter
            }
            let found = null;
            angular.forEach(activities, function (activity) {
                if (activity.Name.toLowerCase() == activityName) {
                    found = activity;
                }
            });
            if (!found) {
                return new Error("no-activity", "Aktiviteten blev ikke fundet");
            }
            return found;

            // const oActivity = (factory.params.activity); // HouseCategory
        });
    };

    // factory.getCurrentActivityId = function () {

    //     return houseService.searchFilter.houseCategory.CategoryId;
    // };

    return factory;
}
